//Calculates bytes to megabytes
export function bytesToMegabytes(
    bytes: number,
    options: { withUnitLabel: string; roundDecimal?: number } | null = {
        withUnitLabel: 'Mb',
        roundDecimal: 2
    }
) {
    const decimalSpot = options?.roundDecimal ? Math.pow(10, options.roundDecimal) : 1;
    return Math.round((bytes / (1024 * 1024)) * decimalSpot) / decimalSpot + (options?.withUnitLabel || '');
}

export function estimateBase64Size(base64String: string, returnAsMb: boolean = true) {
    const subtraction = base64String.indexOf('==') > -1 ? 2 : 1;
    const estimatedSize = (base64String.length || 0) * (3 / 4) - subtraction;

    if (returnAsMb) {
        return Number(bytesToMegabytes(estimatedSize));
    }

    return estimatedSize;
}
